/**
 * Brand assets loaded at runtime (e.g. logo from URL).
 * Override via REACT_APP_LOGO_URL in .env if needed.
 */
export const LOGO_URL =
  process.env.REACT_APP_LOGO_URL ||
  '/images/logo.png';
